import React from "react"
import PageTemplate from "../components/pageTemplate"
import { Container, Row, Col } from "reactstrap"
import { FaCode, FaGithub, FaBolt, FaHome, FaHandsHelping,FaProjectDiagram } from "react-icons/fa"
import Box from "../components/box"
import SEO from "../components/seo"

let Portfolio = ({ title, description, example }) => (
  <Col xs={12} md={4} className="mb-4">
    {/* <Link to="/"> */}
      <Box>
        {/* <Icon size={40} style={{display: 'inline-block', borderRadius: '60px', padding: '0.7em 0.6em', color:"white", backgroundColor: '#b23a48'}}/> */}
        
        <p className="mt-3" style={{fontWeight:'bold'}}>{title}</p>
        <p className="mt-3">{description}</p>
        
        <p className="mt-3">{example}</p>
      </Box>
    {/* </Link> */}
  </Col>
)

let Projects = () => (
  <PageTemplate title="Projects">
    <SEO title="Projects" />
    <Container className="py-5">
    <h2 className="text-center mb-5" style={{fontWeight:'900'}}>Software Development</h2>
      <Row>
        <Portfolio title="Development of Sistem Sewaan for Majlis Perbandaran Hulu Selangor"/>
        <Portfolio title="Development of Source Code Management System for Felda Prodata (M) Sdn. Bhd."/>
        <Portfolio title="Corporate Website (with Online Zakat Payment) and Mobile Apps for Majlis Agama Islam Perlis (MAIPs)"/>
      </Row>
      <Row>
        <Portfolio title="Enhancement and Maintenance of ePBT 2.0 for Kementerian Perumahan dan Kerajaan Tempatan (KPKT)"/>
        <Portfolio title="Development of MBPJ Smart Valuation System Map"/>
        <Portfolio title="Development and Maintenance of Sistem Pengurusan Aset (SISPAC) for Pertubuhan Keselamatan Sosial (PERKESO)"/>
      </Row>
      <Row>
        <Portfolio title="Development and Maintenance of OSC 3.0 Plus for Kementerian Perumahan dan Kerajaan Tempatan (KPKT)"/>
        <Portfolio title="Development anDevelopment of e-IPTS for Ministry of Higher Education (MOHE)"/>
        <Portfolio title="Development of Staff Portal (eCommunity) for Universiti Malaysia Pahang (UMP)"/>
      </Row>
      <Row>
        <Portfolio title="Helpdesk System for Venture Nucleus Sdn. Bhd."/>
        <Portfolio title="Corporate Website for Onecare Consulting Sdn. Bhd."/>
        <Portfolio title="Development of Railways Asset Intelligence System for Railway Assets Corporation (RAC)"/>
      </Row>
      <Row>
        <Portfolio title="Point-of-Sales System for Glocal Link Sdn. Bhd."/>
        <Portfolio title="Helpdesk System for Octal Resources Sdn. Bhd."/>
        <Portfolio title="Helpdesk System for Lunas Technology Sdn. Bhd."/>
      </Row>
      <Row>
        <Portfolio title="Corporate Website for Ziantech Solutions Sdn. Bhd."/>
      </Row>
    </Container>
    <Container className="py-5">
    <h2 className="text-center mb-5" style={{fontWeight:'900'}}>ICT Vendor</h2>
      <Row>
        <Portfolio title="ICT Preventive Maintenance in Dewan Bandaraya Kuala Lumpur – For Octal Resources Sdn Bhd"/>
        <Portfolio title="ICT Preventive Maintenance at MOE Perak for RHL Engineering Sdn. Bhd."/>
        <Portfolio title="ICT Preventive Maintenance for Hospital Sungai Buloh for Solutions Protocol Sdn. Bhd."/>
      </Row>
      <Row>
        <Portfolio title="Supply, install, configure, test and commission computers and notebooks for Glocal Link Sdn. Bhd. (MARA subsidiary)"/>
      </Row>
    </Container>
    <Container className="py-5">
    <h2 className="text-center mb-5" style={{fontWeight:'900'}}>ICT Network</h2>
      <Row>
        <Portfolio title="Network design, configuration and installation for Menara Felda under Novarank Sdn. Bhd."/>
        <Portfolio title="Network cabling installation for Scan Global Logistics Sdn. Bhd."/>
        <Portfolio title="Network cabling installation at UKM-MTDC under KH Fiber Technology"/>
      </Row>
      <Row>
        <Portfolio title="Network cabling installation at UPSI Tanjung Malim"/>
        <Portfolio title="WiFi and Network cabling installation at Fakulti Farmasi, Universiti Malaya"/>
      </Row>
    </Container>
    <Container className="py-5">
        <h2 className="text-center mb-5" style={{fontWeight:'900'}}>HSBB Installation</h2>
      <Row>
        <Portfolio title="Installer for UniFi (TM High-Speed Broadband) under Fibercomm Sdn. Bhd., MyBroadband Sdn. Bhd., Muin Communication Sdn. Bhd., Sakol Enterprise Sdn. Bhd. & Dataran Maksima Sdn. Bhd. (under Business Information Technology Sdn. Bhd.)"/>
        <Portfolio title="ICT Preventive Maintenance at MOE Perak for RHL Engineering Sdn. Bhd."/>
        <Portfolio title="Installer for TIME High-Speed Broadband under ETD Makmur"/>
      </Row>
    </Container>
    <Container className="py-5">
        <h2 className="text-center mb-5" style={{fontWeight:'900'}}>Telco</h2>
      <Row>
        <Portfolio title="YTL 1BestariNet Project under Sigma Setia" description="Installation of IDU and microwave equipments at towers in designated school territory"/>
        <Portfolio title="Digi D Nemo Project under ATSB" description="Installation of ZTE RRU & BBU at designated towers for 2G and 3G services"/>
        <Portfolio title="Maxis GABS Project under Binasat Sdn Bhd" description="Maintenance and support (docket) for GABS sites"/>
      </Row>
      <Row>
        <Portfolio title="PICO Repeater Installation for DiGi under Anqa Charm Circle" description="Kin Kee Hardware, Bandar Indera Mahkota, Kuantan, Pahang"/>
        <Portfolio title="DiGi TTDC Lease Fiber Patch Cords Hot Swap (Technical Site Survey & Installation) under Anqa Charm Circle" description="Alma Kijang – Prai MSC,
        Wisma Ganda – Ipoh MSC,
        LAP Tasek – Ipoh MSC,
        LAP Tambun – Ipoh MSC,
        Simpang Pulai – Ipoh MSC,
        Toklin – Prai MSC,
        Vistana Hotel – Prai MSC"/>
        <Portfolio title="Site Survey Maxis GABS Southern (10 sites at Batu Pahat, Johor)"/>
      </Row>
      <Row>
        <Portfolio title="CELCOM NSN LTE Phase 2" description="Swap antenna & boom, install RFM & eNode-B and upgrade rectifier
        Putrajaya Presint 11 (PR_PRESINT11_WPPJ) - 76m 4 Legged Angular Tower – Antenna height : 69.5m"/>
        <Portfolio title="DiGi Antenna Swap under D LA Technology Sdn. Bhd" description="Install/swap/add antenna Bi-Sector and RRU with accessories.
        2274A Taman Kajang Mulia - 45m Monopole Tower – Antenna height : 34m"/>
        <Portfolio title="Site Survey Maxis GABS Northern (19 sites at Alor Star & Sungai Petani, Kedah)"/>
      </Row>
      <Row>
        <Portfolio title="DiGi LTE under ASHtech Engineering" description="Install/swap/add antenna and RRU with accessories.
        1597B Jalan Putra Rel - Rooftop"/>
        <Portfolio title="DiGi LTE under ASHtech Engineering" description="Install/swap/add antenna and RRU with accessories.
        1183B Metro Perdana Kepong - Rooftop"/>
        <Portfolio title="DiGi DWDM Fiber Patching (Northern Region) under Anqa Charm Circle" description="Ipoh MSC,
        LAP Tambun,
        Tapah Road,
        TAR College Kampar,
        Hutan Melintang,
        KTM Sungai Siput,
        KTM Kuala Kangsar,
        KTM Taiping,
        Prai MSC,
        KTM Parit Buntar,
        Nibong Tebal 2,
        Bagan Serai"/>
      </Row>
          <Row>
            <Portfolio title="CME Works at DiGi Site Pearl Point, Jalan Klang Lama, KL under Cube Communications Sdn Bhd" description="Build plinth and install boom with 2 support
            Supply and install cable tray"/>
            <Portfolio title="CME Works at DiGi Site 4363B Sungai Juar, Perak under D LA Technology Sdn Bhd" description="Perform Technical Site Survey
            Install tower plate with accessories"/>
            <Portfolio title="Celcom Fixed Wireless Access under Samudra Communications Sdn Bhd" description="KFC Bandar Sungai Long,
            KFC Sungai Chua,
            KFC Taman Desa Rishah,
            TNB Selama,
            TNB Gudang Jasin"/>
          </Row>
    </Container>
  </PageTemplate>
)

export default Projects